import { FirebaseOptions } from 'firebase/app';

export const STAGE = process.env.REACT_APP_ENV?.toUpperCase() || 'DEVELOPMENT';
export const LOGIN_ENABLED = true;

export type EnvConfig = {
	firebaseConfig: FirebaseOptions;
	endpoints: {
		clientsAdd: string; 
		reservationsAdd: string;
		reservationsAccept: string;
		lessonStatusUpdate: string;
		lessonStatusUpdateAdmin: string;
		lessonRescheduleProposal: string;
		lessonRescheduleReject: string;
		lessonRescheduleAccept: string;
		clientPanelInvitation: string;
		sendEmail: string;
	};
};

const getEnv = (): EnvConfig => {
	console.info(`Using ${STAGE} config`);
	
	return {
		firebaseConfig: {
			apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
			authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
			databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
			projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
			storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
			messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
			appId: process.env.REACT_APP_FIREBASE_APP_ID,
			measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
		},
		endpoints: {
			clientsAdd: process.env.REACT_APP_API_CLIENTS_ADD_URL || '',
			reservationsAdd: process.env.REACT_APP_API_RESERVATIONS_ADD_URL || '',
			reservationsAccept: process.env.REACT_APP_API_RESERVATIONS_ACCEPT_URL || '',
			lessonStatusUpdate: process.env.REACT_APP_API_LESSONS_STATUS_UPDATE_URL || '',
			lessonStatusUpdateAdmin: process.env.REACT_APP_API_LESSONS_STATUS_UPDATE_ADMIN_URL || '',
			lessonRescheduleProposal: process.env.REACT_APP_API_LESSONS_RESCHEDULE_PROPOSAL_URL || '',
			lessonRescheduleReject: process.env.REACT_APP_API_LESSONS_RESCHEDULE_REJECT_URL || '',
			lessonRescheduleAccept: process.env.REACT_APP_API_LESSONS_RESCHEDULE_ACCEPT_URL || '',
			clientPanelInvitation: process.env.REACT_APP_API_CLIENT_PANEL_INVITATION_URL || '',
			sendEmail: process.env.REACT_APP_API_SEND_EMAIL_URL || '',
		},
	};
};

const env: EnvConfig = getEnv();
export default env;